import DocsModel from '../models/DocsModel'

export const docsUpdateForm = (formData, complete = false, error = '') => {
    return {
        type: 'DOCS_UPDATE_FORM',
        formData,
        complete,
        error
    }
}

export const docsOpenForm = (formData) => {
    return {
        type: 'DOCS_OPEN_FORM',
        formData
    }
}

export const docsStore = (formData) => {
    return (dispatch) => {
        DocsModel.store(formData, (result) => {
            if (result.id) {
                formData['id'] = result.id
                formData['filename'] = result.filename
                formData['mime'] = result.mime
            }
            formData['complete'] = true
            dispatch(docsUpdateForm(formData, true, result.error))
        })
    }
}

export const docsResetForm = () => {
    return (dispatch) => {
        var formData = DocsModel.dispense()
        dispatch(docsOpenForm(formData))
    }
}

export const publicLoadOwnDocs = () => {
    return (dispatch) => {
        DocsModel.findOwn((result) => {
            dispatch({type: 'PUBLIC_DOCS_LOAD', items: result})
        })
    }
}

export const publicLoadDocsItem = (id) => {
    return (dispatch) => {
        if (!id) return dispatch(docsOpenForm(DocsModel.dispense()))
        DocsModel.find(id, (formData) => {
            dispatch(docsOpenForm(formData))
        })
    }
}

export const publicDelDocsItem = (item) => {
    return (dispatch) => {
        DocsModel.remove(item, (result) => {
            dispatch(publicLoadOwnDocs())
        })
    }
}

export const publicDelUploadItem = (item) => {
    return (dispatch) => {
        DocsModel.removeUpload(item, (result) => {
            // Remove done
        })
    }
}

export const publicDelTempUploadItem = (item) => {
    return (dispatch) => {
        DocsModel.removeTempUpload(item, (result) => {
            // Remove done
        })
    }
}

export const publicLoadDocsView = (id) => {
    return (dispatch) => {
        if (!id) return dispatch(docsOpenView(DocsModel.dispense()))
        DocsModel.find(id, (data) => {
            dispatch(docsOpenView(data))
        })
    }
}

export const docsOpenView = (data) => {
    return {
        type: 'DOCS_OPEN_VIEW',
        data
    }
}



// WEBPACK FOOTER //
// ./src/actions/docs.js